import clone from "clone";
import { dom } from "@fortawesome/fontawesome-svg-core";
import menu from "../../constants/menu";

const state = {
  items: [],
  initialised: false,
};

/* eslint-disable no-shadow, no-param-reassign */
const mutations = {
  initialise(state, payload) {
    const { menuFilter } = payload;
    const menuItems = clone(menu.items).filter(menuFilter);

    let hidden = [];
    if (process.env.VUE_APP_HIDDEN_MENUS && process.env.VUE_APP_HIDDEN_MENUS.length) {
      hidden = process.env.VUE_APP_HIDDEN_MENUS.split(",");
    }

    // Update Dash menu item
    state.items = menuItems.reduce((filtered, item) => {
      if (!hidden.includes(item.name)) {
        switch (item.name) {
          case "Buzz":
          case "DASH":
          case "ProspectR":
            item.url = item.url ? new URL(item.url).origin : null;
            break;

          default:
            break;
        }

        filtered.push(item);
      }
      return filtered;
    }, []);

    setTimeout(() => {
      dom.i2svg({ node: document.querySelectorAll(".sidebar-nav")[0] });
    }, 50);

    state.initialised = true;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
